<template>
  <div class="swoosh" :style="backgroundStyle()">
    <div class="swoosh-text-container">
      <p class="swoosh-text">{{ swooshText }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    swooshText: {
      type: String,
      required: true
    },
    background: {
      type: String,
      required: true
    }
  },
  methods: {
    backgroundStyle: function () {
      if (this.background.length > 8) {
        return { backgroundImage: `url(${this.background})` }
      } else {
        return { background: this.background }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~styles/utils.scss';
.swoosh {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
  height: 40%;
  position: absolute;
  z-index: 1;
  bottom: 0;
  background-size: cover;
  background-position: 100% 50%;
  clip-path: path('M 0 57 C 123 114 198 13 340 60 L 340 146 L 0 150 Z');
  &-text-container {
    width: 100%;
    height: 38%;
    padding: 0 5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &-text {
    font-family: $swoosh-font;
    font-size: 1.4rem;
    font-weight: 600;
    line-height: 1.1rem;
    color: white;
    text-align: center;
    text-transform: uppercase;
  }
}
</style>
